import { Fragment, useRef } from "react";
import {
    TokenIconSize,
    TokenBadge,
    IconDownFill,
    Copy,
} from "~/components/index.tsx";
import ModalTokenList from "~/components/ModalTokenList";
import { isBuiltInToken } from "~/pages/Trade/utils";
import { formatAddress } from "~/utils/format";

export default function TokenSelect({
    symbol,
    logo,
    chainName,
    chainLogo,
    contract,
    tokenSelectCallback = () => {},
}: {
    symbol: string;
    logo: string;
    chainName: string;
    chainLogo: string;
    chainId: string;
    contract?: string;
    tokenSelectCallback?: () => void;
}) {
    const refModalTokenList = useRef<{ open: () => void }>();

    return (
        <Fragment>
            <div className="flex items-center">
                <div>
                    <TokenBadge
                        size={TokenIconSize.size40}
                        tailIconSize={TokenIconSize.mini}
                        tailIconClass="!border-[1.5px]"
                        icon={logo}
                        tokenIconBorder={true}
                        chainIcon={chainLogo}
                        symbol={symbol}
                        chainName={chainName}
                    />
                </div>
                <div className="ml-[10px]">
                    <div
                        className="flex items-center cursor-pointer"
                        onClick={() => refModalTokenList.current?.open()}
                    >
                        <div className="text-body1 font-Semibold text-text_1">
                            {symbol}
                        </div>
                        <IconDownFill className="text-text_1 text-[14px]" />
                    </div>
                    {contract && !isBuiltInToken(contract) ? (
                        <Copy
                            copyText={contract}
                            iconClassName="text-text_2 text-direction1"
                        >
                            <div className="text-direction1 font-Regular text-text_2">
                                {formatAddress(contract)}
                            </div>
                        </Copy>
                    ) : (
                        <div className="text-direction1 font-Regular text-text_2">
                            {chainName}
                        </div>
                    )}
                </div>
            </div>

            <ModalTokenList
                ref={refModalTokenList}
                tokenSelectCallback={tokenSelectCallback}
            />
        </Fragment>
    );
}
